import { IWorkflowNode } from "motw_core/Entity/IWorkflowNode";
import * as React from "react";
import classNames from "classnames";
import { EGlyphicon } from "source/app/presentation/Shared/Glyphicon/EGlyphicon";
import IconWithText from "source/app/services/Shared/IconWithText/IconWithText";
import * as styles from "../EditNodeDetails.css";
import { nodeOptionsLinkStyleClass } from "../nodeOptionsLinkStyleClass";

export function ShowNodeId({ rootNode }: { rootNode: IWorkflowNode }) {
    const nodeId = rootNode.id.toString();

    return (
        <div className={styles.nodeIdRow}>
            <span className={styles.nodeIdIdentity}>
                <span className={styles.nodeIdLabel}>Workflow node ID</span>
                <span className={styles.nodeId}>{nodeId}</span>
            </span>
            <IconWithText
                whenClicked={() => navigator.clipboard.writeText(nodeId)}
                iconSuffix={EGlyphicon.copy}
                displayAsBlock={false}
                withClass={classNames(
                    nodeOptionsLinkStyleClass,
                    styles.copyAction
                )}
            >
                Copy
            </IconWithText>
        </div>
    );
}
